import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Date",
    type: "object",
    properties: {
      ...Utils.properties,
      // Empty, not `new Date().toISOString()` as the project this came from had
      // it. That expression runs at import time, so the schema differed between
      // two processes that loaded it a second apart — which makes every
      // structural comparison of the document (the form's dirty check, the
      // parity tests) depend on the clock.
      default: {
        label: "Default value",
        type: "string",
        default: "",
        widget: "date",
      },
    },
    required: [],
  },
];
